import type { FaireProductEntity } from "../../entity_types/product";

export const p_tpdkkhbat6: FaireProductEntity = {
  token: "p_tpdkkhbat6",
  type: "product",
  name: "Hot Dad Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/a5c749e2d387dfe4acc961a769ae6f585971ec0ae7d2c8739716765ba4fb7423.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/14748cbdcd0b6817f64c0db8bf4fe2e555ff05ee76e049dba8a604dc953d2ea8.jpeg",
    "https://cdn.faire.com/fastly/880ec6aa2b46180329c4712235e9d3c35439e857ed06a36c479372054f98b35c.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/bdf9e02a621edf88a3077349379fc5481664e3d5d6ec20b67a9bfde62c4b000a.jpeg",
    "https://cdn.faire.com/fastly/4d06272b475c76cba72bd5a74893bbcbd93133f331303dc87922ee55a345e7c9.jpeg",
    "https://cdn.faire.com/fastly/21696d9f513fd98e92fc4487c264d8b232371b34bca7bd9002eddc3ec23b7ec7.jpeg",
    "https://cdn.faire.com/fastly/a04df95dbf4525d6b1290185bfd43ab2147097e9fa122ced9fbcdb28684157eb.jpeg",
    "https://cdn.faire.com/fastly/4cecd30e160e00150d3f49aa8d13821eaa550eb46c50a2d80e702f2810b106b9.jpeg"
  ],
  priceDollars: 6.75,
  description: "For the guy who mows the lawn shirtless and calls it self-care. These socks say what we’re all thinking: Hot. Dad. 🥵\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:07.247Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
